export default "__VITE_ASSET__Cztyl10X__"